import { useState } from "react";
import styled from "styled-components";
import { BiCalendarAlt, BiChevronDown } from "react-icons/bi";
import { AiOutlinePlusSquare, AiOutlineMinusSquare } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { categorias, getGeneralResults, Search } from "../../../../hooks/useGeneralSearch";
import { Input } from "../../../../components/Input";
import { Toggle } from "../../../../components/Forms";
import { Accordion } from "../../../../components/Accordion";
import { Row } from "../../../../components/Row";
import {indices} from "../../../../mocks/indices"
import { Select } from "../../../../components/Select";
import { TreeSelect } from "../../../../components/TreeSelect";

interface ColumnProps {
  marginLeft: string;
}

interface FieldProps {
  marginBottom?: string;
}

export function Form() {
  const history = useNavigate();

  const [isFormOpen, setIsFormOpen] = useState(false);

  const [initialType, setInitialType] = useState('text');
  const [finalType, setFinalType] = useState('text');

  const [mainSearch, setMainSearch] = useState('');
  const [initialDate, setInitialDate] = useState('');
  const [finalDate, setFinalDate] = useState('');
  const [categoria, setCategoria] = useState('');
  const [indice, setIndice] = useState('');

  const selectCategorias = Object.entries(categorias).map(([key, value]) => (value))

  async function useSubmit(e: any) {
    e.preventDefault();
    const data = await search();
    history(
      '/pesquisa', 
      {
        state: {
          search: getSearch(),
          data 
        }
      }
    ); 
  }

  function getSearch(): Search {
    let search: Search = {};
    if(mainSearch) {
      search.search_text = mainSearch
    }
    if(initialDate) {
      search.initialDate = initialDate
    }
    if(finalDate) {
      search.finalDate = finalDate
    }
    if(categoria) {
      search.categoria = categoria
    }
    if(indice) {
      search.indice = indice
    }
    return search;
  }

  async function search() {
    const result = await getGeneralResults(getSearch());
    return result;
  }


  return (
    <>
      <Toggle onClick={() => setIsFormOpen(!isFormOpen)}>
        <span>Pesquisar</span>
        <AiOutlinePlusSquare display={!isFormOpen? 'block' : 'none'} size={28} cursor={'pointer'} />
        <AiOutlineMinusSquare display={isFormOpen? 'block' : 'none'} size={28} cursor={'pointer'} />
      </Toggle>
      <Accordion isOpen={isFormOpen} forceWidth="auto">
        <Content onSubmit={useSubmit}>
          <Row>

            <Column marginLeft="48px">
              <Label>Busca Livre</Label>
              <Input 
                type="text" 
                placeholder="Pesquisar"
                marginBottom="16px" 
                value={mainSearch}
                minWidth="256px"
                onChange={(value) => setMainSearch(value)}
              />
              <Label>Categoria</Label>
              <Field marginBottom="16px">
                <Select
                    value={categoria}
                    onChange={(value: any) => setCategoria(value)}
                >
                  <option>Selecionar</option>
                  {selectCategorias.map((index: any) => (
                    <option value={index}>{index}</option> 
                  ))}
                </Select>
                <ChevronIcon size={24} />
              </Field>
            </Column>
            <Column marginLeft="80px">
              <Label>Índice</Label>
              <Field marginBottom="16px">
                <TreeSelect 
                  data={indices} 
                  marginBottom="0px"
                  dropdownMaxHeight="600px"
                  value={indice}
                  onChange={(value: any) => setIndice(value)}
                />
                <ChevronIcon size={24} />
              </Field>
              <Label>Busca por data</Label>
              <Field marginBottom="6px">
                <Input 
                  type={initialType} 
                  placeholder="Inicial"
                  value={initialDate}
                  onFocus={() => setInitialType('date')}
                  onChange={(value) => setInitialDate(value)}
                />
                <CalendarIcon />
              </Field>
              <Field marginBottom="6px">
                <Input
                  type={finalType}
                  placeholder="Final" 
                  value={finalDate}
                  onFocus={() => setFinalType('date')}
                  onChange={(value) => setFinalDate(value)} 
                />
                <CalendarIcon />
              </Field>
            </Column>
          </Row>

          <Button>Pesquisar</Button>
        </Content>
      </Accordion>
    </>
  );
}

const Content = styled.form`
  display: flex;
  width: 100%;
  padding: 32px 0 0;
  position: relative;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    padding: 16px 0 32px;
    flex-direction: column;
    overflow: hidden;
  }
`;

const Column = styled.div<ColumnProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-left: ${({ marginLeft }) => marginLeft };

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    margin-left: 0;
  }
`;

const Label = styled.label`
  display: block;
  color: ${({ theme }) => theme.colors.blue.dark };
  text-transform: uppercase;
  font-size: 17px;
  margin-bottom: 16px;
  
  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    font-size: 15px;
    margin-bottom: 8px;
  }
`;

const Field = styled.div<FieldProps>`
  position: relative;
  margin-bottom: ${({ marginBottom }) => marginBottom || 0 };
`;

const CalendarIcon = styled(BiCalendarAlt)`
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  pointer-events: none;
`;

const ChevronIcon = styled(BiChevronDown)`
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  pointer-events: none;
`;

const Button = styled.button`
  display: inline-block;
  background-color: #fff;
  color: ${({ theme }) => theme.colors.blue.dark };
  text-decoration: none;
  text-transform: uppercase;
  width: 100%;
  max-width: 256px;
  height: 72px;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  border: ${({ theme }) => `2px solid ${theme.colors.gray.darker}` };
  position: absolute;
  bottom: 0;
  left: 48px;
  cursor: pointer;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    position: static;
    width: 100%;
    max-width: 100%;
    height: 54px;
    font-size: 20px;
    margin-top: 12px;
  }
`;